import React, { ElementType } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  VStack,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { MdEmail, MdArrowBack, MdBook } from 'react-icons/md';

export default function WebsiteComingSoonPage() {
  const navigate = useNavigate();
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'gray.300');

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="#b1faa13b"
      px={6}
      py={12}
    >
      <Box
        maxW="760px"
        w="100%"
        bg={cardBg}
        rounded="2xl"
        shadow="lg"
        p={{ base: 6, md: 10 }}
        textAlign="center"
      >
        {/* Gmail-style top icon */}
        <Box
          bg="#006400"
          rounded="full"
          p={5}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="md"
          mb={6}
        >
          <Icon as={MdBook as ElementType} boxSize={12} color="white" />
        </Box>

        <Heading size="lg" color="#006400" mb={3}>
          Website - Coming Soon
        </Heading>

        <Text color={textColor} fontSize="md" maxW="620px" mx="auto" mb={6}>
          Get ready for a smarter,website experience inside your CRM.
        </Text>

        <VStack align="start" spacing={2} maxW="620px" mx="auto" mb={8}>
          <Text color={textColor} fontWeight="semibold">
            What to expect:
          </Text>
          <Box
            as="ul"
            pl={4}
            color={textColor}
            alignItems={'flex-start'}
            textAlign={'center'}
            fontSize="sm"
          >
            <li>Unified catalogue management.</li>
            <li>Payments collection.</li>
            <li>CRM-linked activity tracking and reminders.</li>
          </Box>
        </VStack>

        <Flex justify="center" gap={4}>
          <Button
            leftIcon={<Icon as={MdArrowBack as ElementType} boxSize={4} />}
            variant="outline"
            borderColor="#006400"
            color="#006400"
            _hover={{ bg: '#006400', color: 'white' }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>

          <Button
            bg="#006400"
            color="white"
            _hover={{ bg: '#006405' }}
            onClick={() => navigate('/organization/home')}
          >
            Go to Organization Home
          </Button>
        </Flex>

        <Text mt={8} color="gray.500" fontSize="sm">
          Want early access? Contact your admin or email support - beta invites
          open soon.
        </Text>
      </Box>
    </Flex>
  );
}
